<template>
    
    <v-layout row wrap>   
        <v-flex xs12 class="mx-0 px-0">
            <v-card flat dark>
                <v-card-title>
                    <slot name="form-header"></slot>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>                    
                    <slot name="form-fields"></slot>                    
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>        
                    <v-flex xs4 offset-xs6>
                        <slot name="form-commands"></slot>                                                                                         
                    </v-flex>
                </v-card-actions> 
            </v-card>
        </v-flex>
        
    </v-layout>
</template>

<script>



export default {
    
    data() {
        return {
            showSidebar: false
        };
    },
    
    methods: {
        
    }
    
    
}
</script>

<style>
    
</style>




// WEBPACK FOOTER //
// formHelper.vue?716d9dbc